import { computed, unref } from 'vue';

import { propsFactory, paramCase } from '@components/utils';

import type { MaybeRef } from '@components/utils';
import type { ComputedRef, PropType } from 'vue';

export type TSize = typeof allowedSize[number];
export interface ISizeProps {
  size: TSize;
}
export interface IUseSize {
  sizeClasses: ComputedRef<string>;
}

export const allowedSize = ['xs', 'sm', 'md', 'lg', 'xl'] as const;
export const makeSizeProps = propsFactory(
  {
    /**
     * Размер
     */
    size: {
      type: String as PropType<TSize>,
      default: 'md',
      available: allowedSize,
      validator: (value: TSize) => allowedSize.includes(value)
    }
  },
  'size'
);

export function useSize(props: MaybeRef<ISizeProps>, name: string): IUseSize {
  const sizeClasses = computed(() => {
    const { size } = unref(props);
    return `${paramCase(name)}__size--${size}`;
  });

  return { sizeClasses };
}
